import { createSlice } from '@reduxjs/toolkit';

const playerSlice = createSlice({
  name: 'player',
  initialState: {
    currentStory: null,
  },
  reducers: {
    setCurrentStory: (state, action) => {
      state.currentStory = action.payload;
    },
  },
});

export const { setCurrentStory } = playerSlice.actions;
export default playerSlice.reducer;
